import 'animate.css';
import { Pagination } from 'element-ui';
import Vue from 'vue';
import lottie from 'vue-lottie';
import App from './App.vue';
import router from './router';
import store from './store';
import "./utils/animate.min.css";
import './utils/rem.js';
// import animated from 'wowjs/css/libs/animate.css'; //不需要后期修改动画可以直接使用该代码
import animated from './assets/css/animate.css';


Vue.use(Pagination);
Vue.component('lottie',lottie)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(animated);

